import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { FEATURE_FLAGS_QUERY } from './queries'

export function useFeatureFlags(feature: string) {
    const { data, loading, error } = useQuery(FEATURE_FLAGS_QUERY)

    const featureFlags = useMemo(() => data?.listFeatureFlags?.items, [data])
    const hasFeature = useMemo(() => {
        if (!featureFlags) return false
        return !!featureFlags.filter(
            (flag: any) => flag.code === feature && flag.enabled,
        ).length
    }, [feature, featureFlags])

    return { featureFlags, hasFeature, loading, error }
}
